import styled from 'styled-components';

// CONSTANTS
import colors from '@/constants/colors';

export const Button = styled.div`
  border: 2px solid ${colors.skeleton.bg};
  border-radius: 20px;
  height: 40px;
  width: 160px;
`;

export default Button;
